export default "__VITE_ASSET__Cdpc2we0__"